  <!-- 改厕 档案统计-->
<!-- 所有乡镇报抽统计 -->
<template>
    <div class="main-area">
        <div v-if="$route.meta.rank == 2">
            <el-breadcrumb separator=":">
                <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                <el-breadcrumb-item>改厕档案数据统计</el-breadcrumb-item>
            </el-breadcrumb>

            <el-row class="margin-top-10">
                <el-col :span="2" class="margin-top-10">
                    <label class="search-label">
                    改厕日期:
                    </label>
                </el-col>
                <el-col :span="6" class="margin-top-10">
                <el-date-picker
                  v-model="searchForm.year"
                  align="right"
                  type="year"
                   :size="GLOBAL.config.systemSize"
                    value-format="yyyy"
                   format='yyyy年'
                   clearable=""
                  placeholder="选择年份">
                </el-date-picker>
                </el-col>
              <el-col :span="2" class="margin-top-10">
                  <label class="search-label">
                  改厕类型:
                  </label>
              </el-col>
              <el-col :span="6" class="margin-top-10">
                 <!-- <el-select
                           v-model="searchForm.gczt"
                           placeholder="请选择"
                         :size="GLOBAL.config.systemSize"
                          style="width: 100%;" clearable>
                     <el-option
                       v-for="item in dictionary.gczts"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code"
                        :size="GLOBAL.config.systemSize"
                        style="width: 100%;"
                       >
                     </el-option>
                     </el-select> -->
					      <el-select
                  v-model="searchForm.gczt"
                  placeholder="请选择"
                  multiple
                  :size="GLOBAL.config.systemSize"
                  style="width: 100%;" clearable>
					     <el-option
					       v-for="item in dictionary.gczts"
					       :key="item.code"
					       :label="item.name"
					       :value="item.code"
					        :size="GLOBAL.config.systemSize"
					        style="width: 100%;"
					       >
					     </el-option>
					     </el-select>

                </el-col>

                <el-col :span="2" class="margin-top-10">
                    <el-button type="primary" @click="doSearch" :size="GLOBAL.config.systemSize" icon="el-icon-search">查询
                    </el-button>
                </el-col>
				<el-col :span="2" class="margin-top-10">
				    <el-button type="primary" @click="onExport()" :size="GLOBAL.config.systemSize" icon="el-icon-upload2">导出
				    </el-button>
				</el-col>
            </el-row>

            <el-table style="width: 100%"
                :data="tableData"
                element-loading-text="数据处理中...请稍等..."

                v-loading="loading">
                <el-table-column prop="name" label="行政区划" align="center">
                    <template slot-scope="scope" class="cursor" >
                      <el-tooltip v-if="yhlx!=4" class="item" effect="light" content="乡镇明细" placement="right" style="corsor">
                     <span @click="toOne(scope.row.code)">{{scope.row.name}}</span>
                    </el-tooltip>
                     <span v-else @click="toOne(scope.row.code)">{{scope.row.name}}</span>
                  </template>
                </el-table-column>

                <el-table-column prop="countno" :label="nameFlag?'公厕数量':'改厕户数'" align="center" show-overflow-tooltip >
                        <template slot-scope="scope" class="cursor" >
                          <el-tooltip class="item" effect="light" content="改厕明细" placement="right" style="corsor">
                           <span  @click="toTwo(scope.row.code)">{{scope.row.countno}}</span>
                           </el-tooltip>
                        </template>
                </el-table-column>

            </el-table>

        </div>
        <div v-else><router-view></router-view></div>
    </div>
</template>

<script>
export default {
    name: 'GCarchivesStatistics',
    data () {
        return {
            // 查询表单
            searchForm: {
                year: '',
                gczt: []
            },
            tableData: [
            ],
            loading: false,
            yhlx:JSON.parse(localStorage.getItem('gcUserInfo')).yhlx,
            dictionary: {
                // 改厕状态
                gczts: JSON.parse(unescape(localStorage.getItem("GC_TYPE"))),

            },
            nameFlag: false
        }
    },

    methods: {
        toOne(data){
          if(JSON.parse(localStorage.getItem('gcUserInfo')).yhlx=='4'){
            return
          }
          this.$router.push({
            name: 'GCTownsStatistics',
            params: {
              villageCode: data ,
              gcrq: this.searchForm.year,
              gczt: this.arrayTostring( this.searchForm.gczt)

            }
          })


        },
        toTwo(data){
          this.$router.push({
                        name: 'GCarchivesStatisticsInfo',
                        params: {
                          code: data,
                          gcrq: this.searchForm.year,
                          gczt: this.arrayTostring(  this.searchForm.gczt)

                        }
                      })
        },
        changeIndex (data, column, cell, event) {


          if(column.label=='行政区划'){

          }else if(column.label=='改厕户数'){
            // debugger

          }

        },
        doSearch () {
            let arr = []
            if (this.searchForm.gczt) {
              arr = this.searchForm.gczt.join(',')
            }
            if (arr.length === 1 && arr[0] === '4') {
              this.nameFlag = true
            } else {
              this.nameFlag = false
            }
            this.getTableData()
        },
        // 分页方法
        tableSizeChange: function (pageSize) {
            this.pagination.pageSize = pageSize
            this.getTableData()
        },
        currentChange: function (current) {
            this.pagination.currentPage = current
            this.getTableData()
        },
        getTableData (initPageFlag) {
            this.loading = true
            let _this = this, searchParams = this.searchForm

            _this.FUNCTIONS.systemFunction.removeNullFields(searchParams)
            // var reg = /-| |:/g
            // if (_this.searchForm.updateTime) {
            //     if (_this.searchForm.updateTime[0]) {
            //         beginTime = _this.searchForm.updateTime[0].replace(reg, '') + '00'
            //     }
            //     if (_this.searchForm.updateTime[1]) {
            //         endTime = _this.searchForm.updateTime[1].replace(reg, '') + '00'
            //     }
            // }
            // 3、 调接口获取数据

            let param = {
                // baseService : "TGcBxxxServiceImpl",
                baseService: _this.GLOBAL.config.baseServiceType.TGcBcxxServiceImpl,
                code:JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm,
                gcrq: searchParams.year,
                gczt: _this.arrayTostring( searchParams.gczt)


            }
            // _this.FUNCTIONS.systemFunction.jsonPost(
            //     _this.CONFIG.urls.root + _this.CONFIG.urls.business.zxUser,
            //     param,
            console.log(JSON.stringify(param))
            _this.FUNCTIONS.systemFunction.interactiveData(
                _this,
                _this.GLOBAL.config.businessFlag.zxUser,
                // "getVillages",
                _this.GLOBAL.config.handleType.getGcInfoTotal,
                param,
                null,
                resultData => {
                    _this.loading = false
                    if (resultData) {
                        // 结果参数赋值
                        _this.tableData = resultData.obj
                    } else {
                        _this.$message.warning('获取列表数据失败～')
                    }
                },
                () => {
                    _this.loading = false
                }
            )
        },
        onExport(){
         let info={
               "code":JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm,
               "gcrq":this.searchForm.year,
               "gczt":this.arrayTostring(  this.searchForm.gczt)
               // "month":this.form.month
             }
           let  path='//gcdaReportForm'
          let name ="改厕户数报表.xlsx"
          // console.log(this.form.year)
           this.FUNCTIONS.systemFunction.postDownFileurl(this, {
              info: info
          },this.CONFIG.urls.root + this.CONFIG.urls.business.downLoad +path,name)

        },
        // 所选数组转化为字符串
        arrayTostring(data){
          if(data&&data.length>0){
            data=data.join(',')
          }else{
            data=''
          }
          return data

        }


    },
    mounted () {
        this.getTableData()
    }
}
</script>

<style scoped>
    a {
        text-decoration: none;
    }

   .el-table .cell .el-tooltip{
      cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/statistics/GCarchivesStatistics.vue